import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import '../Checklist/index.css';
import './index.css';
import GoogleMapComponent from '../GoogleMap';
import { Modal } from 'react-bootstrap';
import APIService from '../../Services/APIService';

const AdditionalAttributeModal = ({ key, isVisible, attributes, onChange, onClose, attribute }) => {
  // additional_attributes

  const [additionalAttributes, setAdditionalAttributes] = useState(attributes || []);
  const [latitude, setLatitude] = useState(undefined);
  const [longitude, setLongitude] = useState(undefined);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [subAreas, setSubAreas] = useState([]);
  const [stateList, setStateList] = useState([]);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '5px 10px 10px',
      maxHeight: '550px',
      minHeight: '200px',
    },
  };

  const customSelectStyles = {
    input: () => ({
      height: '24px',
    }),
  };

  const getStateList = async () => {
    // let res = await APIService.get(`/v0/ui/dynamic-location/state/`);
    let res = await APIService.get(`/v0/ui/state/`);
    if (res.status == 200) setStateList(res.data);
  };
  const getCities = async (id) => {
    // let res = await APIService.get(`/v0/ui/dynamic-location/city-by-state/${id}/`);
    let res = await APIService.get(`/v0/ui/create_supplier/load_initial_data/?id=${id}`);
    if (res.status == 200) setCities(res.data?.cities);
  };
  const getAreas = async (id) => {
    // let res = await APIService.get(`/v0/ui/dynamic-location/area-by-city/${id}/`);
    let res = await APIService.get(`/v0/ui/locations/${id}/?type=areas`);
    if (res.status == 200) setAreas(res.data);
  };
  const getSubAreas = async (id) => {
    let res = await APIService.get(`/v0/ui/dynamic-location/sub-area-by-area/${id}/`);
    if (res.status == 200) setSubAreas(res.data);
  };

  useEffect(() => {
    if (additionalAttributes.length) {
      additionalAttributes.forEach((attribute) => {
        if (attribute.name === 'Latitude') {
          setLatitude(attribute.value);
        }
        if (attribute.name === 'Longitude') {
          setLongitude(attribute.value);
        }
      });
    }
    getStateList();
  }, []);

  const handleAttributeChange = (attribute, index) => {
    let additionalAttribute = [...additionalAttributes];
    additionalAttribute[index] = { ...attribute };
    setAdditionalAttributes(additionalAttribute);
  };

  const onSubmit = () => {
    const newAttributes = [...additionalAttributes];
    onChange(newAttributes);
    // Close modal on submit
    onClose();
  };

  const renderAttributeRow = (attribute, index) => {
    if (attribute.isChecked === false) return;
    return (
      <div className="createform__form__row" key={attribute.name}>
        <div className="createform__form__inline supplier-modal-input">
          <div className="form-control">
            <input type="text" value={attribute.name} disabled />
          </div>
          <div className="form-control">{renderAttributeInput(attribute, index)}</div>
        </div>
      </div>
    );
  };

  const renderAttributeInput = (attribute, attrIndex) => {
    const onValueChange = (event) => {
      const newAttribute = Object.assign({}, attribute);

      if (event.target.type === 'number') {
        newAttribute.value = parseFloat(event.target.value);
      } else {
        newAttribute.value = event.target.value;
      }
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onDropDownAttributeValueChange = (newValue) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.value = newValue.value;
      console.log(newValue, 'newValue');
      switch (newAttribute.name) {
        case 'State':
          getCities(newValue.id);
          break;
        case 'City':
          getAreas(newValue.id);
          break;
        case 'Area':
          getSubAreas(newValue.id);
          break;
        default:
          break;
      }

      handleAttributeChange(newAttribute, attrIndex);
    };

    switch (attribute.type) {
      case 'FLOAT':
        return (
          <input
            type="number"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
            // disabled={isDisabled}
          />
        );
      case 'STRING':
        return (
          <input
            type="text"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
            // disabled={isDisabled}
          />
        );
      case 'EMAIL':
        return (
          <input
            type="email"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
            // disabled={isDisabled}
          />
        );
      case 'DROPDOWN':
        let attributeValueOptions = [];
        if (attribute.name == 'State') {
          attribute.options.forEach((option) => {
            attributeValueOptions.push({
              label: option.state_name,
              value: option.state_name,
              id: option.id,
            });
          });
        } else if (attribute.name == 'City') {
          attribute.options.forEach((option) => {
            attributeValueOptions.push({
              label: option.city_name,
              value: option.city_name,
              id: option.id,
            });
          });
        } else if (attribute.name == 'Area') {
          attribute.options.forEach((option) => {
            attributeValueOptions.push({
              label: option.label,
              value: option.label,
              id: option.id,
            });
          });
        } else if (attribute.name == 'Sub Area') {
          attribute.options.forEach((option) => {
            attributeValueOptions.push({
              label: option.subarea_name,
              value: option.subarea_name,
              id: option.id,
            });
          });
        } else {
          attribute.options.forEach((option) => {
            attributeValueOptions.push({ label: option, value: option });
          });
        }

        return (
          <Select
            styles={customSelectStyles}
            options={attributeValueOptions}
            value={attribute.value}
            onChange={onDropDownAttributeValueChange}
            // disabled={isDisabled}
          />
        );
      default:
        return;
    }
  };

  // const { isVisible, attributes, onClose, attribute, locationData } = this.props;
  if (attributes.length && attribute === 'location_details') {
    if (stateList.length) {
      attributes[5].options = [];
      stateList.forEach((item) => {
        attributes[5].options.push(item);
      });
    }
    if (cities.length) {
      attributes[4].options = [];
      cities.forEach((item) => {
        attributes[4].options.push(item);
      });
    }

    if (areas.length) {
      attributes[2].options = [];
      areas.forEach((item) => {
        attributes[2].options.push(item);
      });
    }
    if (subAreas.length) {
      attributes[3].options = [];
      subAreas.forEach((item) => {
        attributes[3].options.push(item);
      });
    }
  }

  // if (attributes.length && attribute === 'location_details') {
  //   if (locationData.states.length) {
  //     attributes[5].options = [];
  //     locationData.states.forEach((item) => {
  //       attributes[5].options.push(item);
  //     });
  //   }
  //   if (locationData.cities.length) {
  //     attributes[4].options = [];
  //     locationData.cities.forEach((item) => {
  //       attributes[4].options.push(item);
  //     });
  //   }

  //   if (locationData.areas.length) {
  //     attributes[2].options = [];
  //     locationData.areas.forEach((item) => {
  //       attributes[2].options.push(item);
  //     });
  //   }
  //   if (locationData.subareas.length) {
  //     attributes[3].options = [];
  //     locationData.subareas.forEach((item) => {
  //       attributes[3].options.push(item);
  //     });
  //   }
  // }

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      className={'theme-modal'}
      style={customStyles}
      id={attribute?.name}
      size={'md'}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Fill Additional Attributes</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {latitude && longitude ? (
          <div>
            <GoogleMapComponent latitude={latitude} longitude={longitude} />
          </div>
        ) : null}
        <div className="createform__form">
          {attributes.length ? attributes.map(renderAttributeRow) : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-footer">
          <button type="button" className="btn btn--danger" onClick={onSubmit}>
            Submit
          </button>{' '}
          <button type="button" className="btn btn--danger" onClick={onClose}>
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AdditionalAttributeModal;
